<template>
  <div>
    <div class="head-box">
      <h4>工作类型</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增工作类型</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-in:state|array-integer#and': '0,1',
              beanName: 'workType',
              title: '工作类型列表'
            })
          "
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
          <el-table-column label="名称" fixed show-overflow-tooltip prop="name">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="$router.push({ path: `/workType/${scope.row._id}` })"
                type="text"
              >
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="估计工期" prop="estimatedDuration">
            <template slot-scope="scope">
              <span>
                {{ scope.row.estimatedDuration }}
                {{ formatDurationType(scope.row.durationType) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="minimumCrewSize" label="最小工作人数"></el-table-column>
          <el-table-column prop="recommendedCrewSize" label="推荐工作人数"></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="140px"
            sortable
          ></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="工作类型" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="100px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item label="估计工期" prop="estimatedDuration">
          <el-input v-model="formData.estimatedDuration" type="number" min="0">
            <el-select
              v-model="formData.durationType"
              slot="append"
              placeholder="请选择单位"
              style="width: 115px;"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                :key="i"
                v-for="(item, i) in options.durationType"
              ></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="最小工作人数" prop="minimumCrewSize">
          <el-input-number
            v-model="formData.minimumCrewSize"
            :controls="false"
            :precision="0"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="推荐工作人数" prop="recommendedCrewSize">
          <el-input-number
            v-model="formData.recommendedCrewSize"
            :controls="false"
            :precision="0"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'workTypes',
  data() {
    window.$this = this;
    return {
      name: 'workType',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        exts: {},
        durationType: 'hours'
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_durationType: { codeId: 'durationType' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'workType',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (var item of res.data) {
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.$util.renderExtField(this.extFields, this.formData);
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    formatDurationType(value) {
      return this.osg.codelabel('durationType', value);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/workType/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {}, durationType: 'hours' };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveExtField(this.extFields, params);
        this.osg.ajax('biz/workType/upsert.do', params, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`biz/workType/enable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/workType/disable/${id}.do`, null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/workType/remove/${id}.do`, null, res => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    }
  }
};
</script>
